import React from 'react'

import {
  func, bool, shape, string, number, oneOfType,
} from 'prop-types'

import { MULTIPLE_PARTS_DEFAULTS } from 'Pods/Profile/Products/ModelUploader/Components/constants'

import PreSupported from './Components/PreSupported/PreSupported'
import Units from './Components/Units/Units'

function PrintableModelDetails({
  printableTechDetails = {
    units: null,
    isPreSupported: false,
    isSplitIntoMultipleParts: false,
    multiplePartsDetails: MULTIPLE_PARTS_DEFAULTS,
  },
  onDetailsChange,
  onMultipleDetailsChange,
  showErrors = false,
}) {
  return (
    <div className="row">
      <Units
        printableTechDetails={printableTechDetails}
        onDetailsChange={onDetailsChange}
        showErrors={showErrors}
      />
      <PreSupported
        printableTechDetails={printableTechDetails}
        onDetailsChange={onDetailsChange}
        onMultipleDetailsChange={onMultipleDetailsChange}
      />
    </div>
  )
}

PrintableModelDetails.propTypes = {
  onDetailsChange: func.isRequired,
  onMultipleDetailsChange: func.isRequired,
  showErrors: bool,
  printableTechDetails: shape({
    units: string,
    isPreSupported: bool,
    isSplitIntoMultipleParts: bool,
    multiplePartsDetails: shape({
      numberOfParts: oneOfType([number, string]),
      unit: string,
      width: oneOfType([number, string]),
      depth: oneOfType([number, string]),
      height: oneOfType([number, string]),
      assemblyInstructions: string,
    }),
  }),
}

export default PrintableModelDetails
